import * as c from '../constants/TeacherConstants'

const initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: [
    /*{
      proId: 0,
      teacherName: 'John Smith'
    }*/
  ],
  org: {
    /*{
     proId: 1,
     teacherName: 'Jane Smith'
     }*/
  },
}

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    // FETCH
    case c.FETCH_TEACHERS_PENDING:
      return { ...state, fetching: true, fetched: false, data: [] }
    case c.FETCH_TEACHERS_FULFILLED:
      return { ...state, data: payload.data, fetching: false, fetched: true }
    case c.FETCH_ORG_TEACHERS_FULFILLED:
      return {
        ...state,
        org: { ...state.org, [payload.orgId]: payload.data },
        fetching: false,
        fetched: true,
      }
    case c.FETCH_TEACHERS_REJECTED:
      return { ...state, fetching: false, error: payload }

    default:
      return state
  }
}
